/**
 * mwApp.partners module <br>
 * Work with Parters - distributors, etc
 *
 * @namespace mwApp/partners
 */

import AddDistributorCtrl from './addDistributor.controller'
import AddVoucherBatchCtrl from './addVoucherBatch.controller'
import DistributorsCtrl from './distributors.controller'
import VoucherBatchesCtrl from './voucherBatches.controller'
import partnersConfig from './partners.config'

import {batchProgress} from './voucherBatches.directives'

export default
angular.module('mwApp.partners', [])
  .config(partnersConfig)
  .directive('batchProgress', batchProgress)
  .controller('DistributorsCtrl', DistributorsCtrl)
  .controller('AddDistributorCtrl', AddDistributorCtrl)
  .controller('AddVoucherBatchCtrl', AddVoucherBatchCtrl)
  .controller('VoucherBatchesCtrl', VoucherBatchesCtrl)
